import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  Toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
  },
  BulkActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  BulkText: {
    fontSize: '14px',
    color: 'var(--Gray-600, #475467)',
  },
}));

export const getButtonStyle = (color: string, hasSelection: boolean = true) => ({
  display: 'flex',
  padding: '9px 20px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  boxSizing: 'border-box',
  borderRadius: '8px',
  border: hasSelection ? `1px solid ${color}` : '1px solid #E5E7EB',
  background: hasSelection ? color : '#E5E7EB',
  ':hover': { background: hasSelection ? color : '#E5E7EB', opacity: hasSelection ? 0.9 : 0.5 },
  opacity: hasSelection ? 1 : 0.5,
  cursor: hasSelection ? 'pointer' : 'not-allowed',
});

export { useStyles };
